import {
  Component,
  ContentChild,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Attribute,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';
import { FormControlDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RadioInputComponent } from '../radio-input/radio-input.component';
import { InputDirective } from './../../directives/input.directive';
import { distinctUntilChanged, filter, debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'iq-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  host: {
    class: 'iq-form-field',
    '[class.error]': 'showErrorMessage',
    '[class.has-prefix]': 'prefix !== undefined'
  }
  // ,changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldComponent implements AfterContentInit, OnDestroy {
  @ContentChild(FormControlDirective)
  _formControl: FormControlDirective;

  @ContentChild(InputDirective) _control: InputDirective;

  @ContentChildren(RadioInputComponent) radioInputs: QueryList<
    RadioInputComponent
  >;

  private statusChanges$: Subscription;

  private _hasError: boolean;
  public get hasError() {
    return this._hasError;
  }

  private _label: string;

  @Input()
  public get label() {
    return this._label;
  }

  public set label(val: string) {
    this._label = val;
  }

  private _errorKey: string;

  // key in translate en.json
  @Input()
  public get errorKey() {
    return this._errorKey || 'default';
  }

  public set errorKey(val: string) {
    this._errorKey = val;
  }

  @Input() errorParams: Object;

  get showErrorIcon() {
    if (!this._control) {
      return false;
    }
    return (
      this._control.inputType !== 'checkbox' &&
      this._control.inputType !== 'radio'
    );
  }

  errorMessage: string;

  private _icon: string;

  @Input()
  public get icon() {
    // console.log( '[DEBUG]' , this._formControl );
    return this._icon;
  }

  public set icon(val: string) {
    this._icon = val;
  }

  private _prefix: string;
  @Input() public get prefix() {
    return this._prefix;
  }

  public set prefix(val: string) {
    this._prefix = val;
  }

  private _showErrorMessage: boolean;
  @Input() public get showErrorMessage() {
    return this._showErrorMessage;
  }

  @Output() iconClick = new EventEmitter<void>();

  ngOnDestroy() {
    if (this.statusChanges$) {
      this.statusChanges$.unsubscribe();
    }
  }

  public updateErrorMessage() {
    if (this._formControl) {
      this._showErrorMessage = this._formControl.status === 'INVALID';
      this.renderErrorMessage(this._formControl.status);
      // this.cdr.detectChanges();
    }
  }

  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterContentInit() {
    if (this._formControl) {
      this.statusChanges$ = this._formControl.statusChanges
        .pipe(
          distinctUntilChanged(),
          filter(p => p === 'VALID')
        )
        .subscribe(() => {
          this._hasError = false;
          this._showErrorMessage = false;
          this.errorMessage = null;
          // this.cdr.detectChanges();
        });
    }
  }

  private renderErrorMessage(status: string) {
    if ('INVALID' === status) {
      this._hasError = true;
      const controlErrors = this._formControl.errors;
      if (controlErrors != null) {
        const error: string = Object.keys(controlErrors).pop();
        this.errorMessage = this.evaluateErrorCode(this.errorKey, error);
      }
    } else {
      this._hasError = false;
      this.errorMessage = null;
    }
  }
  private evaluateErrorCode(errorKey: string, error: string) {
    let errorMessage: string = this.translateService.instant(
      `errors.forms.${errorKey}.${error}`,
      this.errorParams
    );
    if (errorMessage.startsWith('errors.')) {
      errorMessage = this.translateService.instant(
        `errors.forms.default.${error}`,
        this.errorParams
      );
    }
    return errorMessage;
  }

  onIconClick() {
    this.iconClick.emit();
  }
  /**
  ngAfterContentInit() {
    if ( this._formControl ) {

      this._formControl.statusChanges.subscribe( status => this.renderErrorMessage( status ) );
    }
      }
  */
}
